import React, { useState, useEffect } from 'react';
import AdminScan from './AdminScan';
import LuckyBoard from './LuckyBoard';
import SelfCheckin from './SelfCheckin';
import DataView from './DataView';

function App() {
  const [view, setView] = useState('board');
  const [isSelfCheckin, setIsSelfCheckin] = useState(false);

  useEffect(() => {
    if (window.location.pathname === '/checkin') {
        setIsSelfCheckin(true);
    }
  }, []);

  if (isSelfCheckin) return <SelfCheckin />;

  return (
    <div style={{fontFamily: 'sans-serif', minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
      {/* HEADER MENU */}
      <div style={{
          padding: '10px 20px', background: '#222', color: '#fff', 
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10
      }}>
        <div style={{fontSize: 20, fontWeight: 'bold', color: '#f1c40f'}}>QUAY SỐ GOSATECH</div>
        
        <div style={{display: 'flex', gap: 5}}>
            <button onClick={() => setView('board')} style={{
                padding: '8px 12px', cursor:'pointer', border: 'none', borderRadius: 4, fontWeight: 'bold',
                background: view==='board' ? '#e74c3c' : '#444', color: 'white'
            }}>🖥️ Quay Số</button>
            
            <button onClick={() => setView('admin')} style={{
                padding: '8px 12px', cursor:'pointer', border: 'none', borderRadius: 4, fontWeight: 'bold',
                background: view==='admin' ? '#3498db' : '#444', color: 'white'
            }}>📷 Admin Quét</button>
            
            <button onClick={() => setView('data')} style={{
                padding: '8px 12px', cursor:'pointer', border: 'none', borderRadius: 4, fontWeight: 'bold',
                background: view==='data' ? '#f39c12' : '#444', color: view==='data' ? 'black' : 'white'
            }}>📂 IMPORT DỮ LIỆU</button>
        </div>
      </div>
      
      {/* BODY */}
      <div style={{flex: 1, background: '#f4f4f4'}}>
        {view === 'board' && <LuckyBoard />}
        {view === 'admin' && <AdminScan />}
        {view === 'data' && <DataView />}
      </div>
    </div>
  );
}
export default App;
